<div class="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-fade-in"
  (click)="onClose()">
  <div
    class="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl shadow-2xl w-full max-w-7xl h-[92vh] flex flex-col animate-fade-in-up overflow-hidden"
    (click)="$event.stopPropagation()">

    <div
      class="px-4 py-3 sm:px-6 sm:py-4 border-b border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3 z-10 bg-white dark:bg-slate-900">
      <div class="flex items-center gap-3">
        <div class="w-2 h-8 bg-amber-400 rounded-full"></div>
        <h3 class="text-sm sm:text-base md:text-lg font-semibold text-slate-800 dark:text-white">
          {{ modalTitle }}
        </h3>
      </div>

      <div class="flex items-center justify-between sm:justify-end gap-3 w-full sm:w-auto">
        <button type="button" (click)="downloadPdf()"
          class="group cursor-pointer flex items-center justify-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg bg-amber-400 hover:bg-amber-500 text-white text-xs sm:text-sm font-bold transition-all shadow-sm hover:shadow-md border-none">
          <span class="material-icons text-base sm:text-lg group-hover:scale-110 transition-transform">download</span>
          ดาวน์โหลด PDF
        </button>

        <div class="h-6 w-px bg-slate-200 dark:bg-slate-700 mx-1"></div>

        <button type="button" (click)="onClose()"
          class="p-2 rounded-full text-slate-400 dark:text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-600 dark:hover:text-slate-300 transition-colors flex items-center justify-center cursor-pointer border-none bg-transparent"
          title="ปิดหน้าต่าง">
          <span class="material-icons text-xl">close</span>
        </button>
      </div>
    </div>

    <div class="flex-1 bg-slate-100 dark:bg-slate-950 p-3 overflow-hidden relative min-h-0">
      <iframe *ngIf="pdfUrl" [src]="pdfUrl"
        class="w-full h-full border-none rounded-xl shadow-inner bg-white"
        title="PDF Preview">
      </iframe>
      <div *ngIf="!pdfUrl" class="w-full h-full flex flex-col items-center justify-center text-slate-400">
        <span class="material-icons text-5xl animate-spin text-amber-500">autorenew</span>
        <p class="text-sm font-bold mt-3">กำลังเตรียมไฟล์ PDF...</p>
      </div>
    </div>
  </div>
</div>
